import React, { PureComponent } from 'react';

import { FormattedMessage, injectIntl, InjectedIntl } from 'react-intl';

import Flag, { FlagGroup } from '@atlaskit/flag';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import messages from './opt-in-error.i18n';
import * as styles from './opt-in-error.style';

type OptInErrorProps = {
  showError: boolean;
};

export default injectIntl(
  class OptInError extends PureComponent<
    OptInErrorProps & {
      intl: InjectedIntl;
    }
  > {
    render() {
      const { intl, showError } = this.props;

      return (
        <FlagGroup>
          {showError ? (
            <Flag
              appearance="error"
              id="opt-in-error"
              icon={
                <ErrorIcon
                  secondaryColor={token('color.icon.danger', colors.R400)}
                  label="error"
                />
              }
              title={intl.formatMessage(messages.title)}
              description={
                <FormattedMessage
                  {...messages.description}
                  values={{
                    support: (
                      <styles.SupportLink
                        href="https://support.atlassian.com/bitbucket-cloud/"
                        target="_blank"
                      >
                        Atlassian Support
                      </styles.SupportLink>
                    ),
                  }}
                />
              }
            />
          ) : null}
        </FlagGroup>
      );
    }
  }
);
